import React from "react";
import PageContent from "../../../common/components/atom/PageContent/PageContent";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import SectionTitle from "../../../common/components/atom/SectionTitle/SectionTitle";
import ChargingSessionList from "../../../features/chargingSession/components/ChargingSessionList";
import { SingleChargingSessionPageDrawer } from "../SingleChargingSessionPage/SingleChargingSessionPage";

export default function ChargingSessionListPage() {
  return (
    <>
    <PageContent>
      <HeaderTitleContent>Rechargements</HeaderTitleContent>
      <div style={{ padding: "20px" }} />
      <SectionTitle iconType="plug-icon" iconSize={11}>
        Listes des rechargements
      </SectionTitle>
      <ChargingSessionList.List />
    </PageContent>
    <SingleChargingSessionPageDrawer />
    </>
  );
}
